/* eslint-disable @angular-eslint/directive-selector */
import {Directive, ElementRef, inject} from '@angular/core'

@Directive({
  selector: '[toastContainer]',
  exportAs: 'toastContainer',
})
export class ToastNotificationContainerDirective {
  private readonly el = inject(ElementRef)

  getContainerElement = (): HTMLElement => this.el.nativeElement
}
